import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Btn from '../ui/Btn';

export default function EmptyState({ hasActiveFilters = false }) {
  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        {hasActiveFilters
          ? 'No tickets match your search. Try adjusting your filters.'
          : 'No tickets yet. Create your first ticket.'}
      </Typography>
      {!hasActiveFilters && (
        <Btn attrBtn={{ component: Link, to: '/ticketing/create' }}>
          Create Ticket
        </Btn>
      )}
    </Box>
  );
}
